import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'wsm-error-boundary';
import Options from '../components/Options';

export const WidgetContainer = ({ options }) => {
	if (Array.isArray(options) && options.length > 0) {
		return (
			<ErrorBoundary newRelicPageAction="WS PCKG ACCESSORIES ERROR BOUNDARY">
				<Options options={options} />
			</ErrorBoundary>
		);
	}
	return null;
};

const mapStateToProps = (state) => {
	return {
		options: state.options
	};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

WidgetContainer.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			id: PropTypes.number.isRequired
		})
	).isRequired
};

export default Widget;
